import { Injectable } from '@angular/core';

import { PrismicData, PrismicDataResponse } from '@dav-model/api/response/prismic-response.model';
import { PrismicService } from '@dav-store/prismic/prismic.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';


import { LOAD_PRISMIC_DATA } from './prismic.actions';
import * as PrismicActions from '../../store/prismic/prismic.actions';


@Injectable()
export class PrismicEffects {
  constructor(private actions$: Actions, private prismicService: PrismicService) {
  }

  getPrismicData$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(LOAD_PRISMIC_DATA),
    switchMap(() =>
      this.prismicService.getPrismicData().pipe(
        map((response: PrismicDataResponse) => response.results[0].data),
        map((data: PrismicData) => {
          return {
            type: PrismicActions.LOAD_PRISMIC_DATA_SUCCESS,
            payload: { data },
          };
        }),
        catchError((error) => {
          console.error('Prismic response error: ', error);

          return of({
            type: PrismicActions.LOAD_PRISMIC_DATA_FAILURE,
            payload: { error: error.statusText },
          });
        })
      )
    )
  ));
}
